import axios from 'axios'

const dev = window.location.host === 'localhost:8080'

const api = axios.create({
  baseURL: dev ? 'http://localhost:8888/' : './kirby/'
  // headers: {
  //   'Content-Type': 'application/json'
  // }
})

export default {
  cache: {},

  async get(name, { params, type } = { type: 'json' }) {
    type = type || 'json'
    name = [name, type].join('.')

    const cacheId = name + (JSON.stringify(params) || '')
    const cached = this.cache[cacheId]

    if (cached) {
      return cached
    } else {
      const { data } = await api.get(name, { params })
      this.cache[cacheId] = data
      return data
    }
  }
}
